import React from 'react';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransition';
import * as styles from './base.scss';
import classnames from 'classnames';
const transitionClass = (direction) => ({
    enter: classnames({
        [styles.forwardEnter]: direction === 'forward',
        [styles.backEnter]: direction === 'back',
    }),
    enterActive: styles.active,
    exit: classnames({
        [styles.forwardLeave]: direction === 'forward',
        [styles.backLeave]: direction === 'back',
    }),
    exitActive: styles.active,
    appear: 'appear',
    appearActive: 'appearActive',
});
export default (props) => (React.createElement(ReactCSSTransitionGroup, { classNames: transitionClass(props.direction), timeout: { enter: 250, exit: 250 } }, props.children));
